"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringMeta$ = exports.StringMeta$outboundSchema = exports.StringMeta$inboundSchema = void 0;
exports.stringMetaToJSON = stringMetaToJSON;
exports.stringMetaFromJSON = stringMetaFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const meta_js_1 = require("./meta.js");
/** @internal */
exports.StringMeta$inboundSchema = z.object({
    meta: z.nullable(meta_js_1.Meta$inboundSchema),
    value: z.nullable(z.string()),
});
/** @internal */
exports.StringMeta$outboundSchema = z.object({
    meta: z.nullable(meta_js_1.Meta$outboundSchema),
    value: z.nullable(z.string()),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var StringMeta$;
(function (StringMeta$) {
    /** @deprecated use `StringMeta$inboundSchema` instead. */
    StringMeta$.inboundSchema = exports.StringMeta$inboundSchema;
    /** @deprecated use `StringMeta$outboundSchema` instead. */
    StringMeta$.outboundSchema = exports.StringMeta$outboundSchema;
})(StringMeta$ || (exports.StringMeta$ = StringMeta$ = {}));
function stringMetaToJSON(stringMeta) {
    return JSON.stringify(exports.StringMeta$outboundSchema.parse(stringMeta));
}
function stringMetaFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.StringMeta$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'StringMeta' from JSON`);
}
//# sourceMappingURL=stringmeta.js.map